import type { Signal } from "@suse-o11y/signal";
import React from "react";

import type { TimelineSummaryRequestWithTimeRange } from "../../../queries/timeline";

export interface TimelineSummaryRequestContextValue {
	request: undefined | TimelineSummaryRequestWithTimeRange;
	refreshCount: number;
}

export const TimelineSummaryRequestContext = React.createContext<null | Signal<TimelineSummaryRequestContextValue>>(
	null,
);
